import React from 'react'

import styled from '@emotion/styled'
import {
  Box,
  Body2,
  Bold,
  Display,
  FlexDirection,
  AlignItems,
  Color,
  TextAlign,
  Image,
} from '@gousto-internal/citrus-react'

import { CreditBlob } from './CreditBlob'
import GoustoLoveBox from './assets/GousoLoveBox.svg'

const YouGetContainer = styled(Box)`
  flex: 1;
  gap: 10px;
`

interface RafYouGetProps {
  credit: string
  supercededCredit?: string
}

export const RafYouGet: React.FC<RafYouGetProps> = ({ credit, supercededCredit }) => (
  <YouGetContainer
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    alignItems={AlignItems.Center}
    gap={[4, 4, 2, 2]}
  >
    <Body2
      color={Color.ColdGrey_800}
      size={5}
      display={[Display.Block, Display.Block, Display.None, Display.None]}
    >
      <Bold>You get</Bold>
    </Body2>
    <Box display={Display.Flex} flexDirection={FlexDirection.Row} alignItems={AlignItems.Center}>
      <Box display="block">
        <Image
          width={['117px', '117px', 'auto', 'auto']}
          height={['72px', '72px', 'auto', 'auto']}
          src={GoustoLoveBox}
          alt="Gouso Love Box"
          fit="contain"
        />
      </Box>
      {/* you get */}
      <Box
        display="flex"
        flexDirection={FlexDirection.Column}
        alignItems={AlignItems.Center}
        gap={[0, 0, 4, 4]}
      >
        <Body2 color={Color.ColdGrey_800} size={4}>
          <Bold display={[Display.None, Display.None, Display.Block, Display.Block]}>You get</Bold>
        </Body2>
        <CreditBlob supercededCredit={supercededCredit} credit={credit} />
        <Body2
          color={Color.ColdGrey_800}
          textAlign={TextAlign.Center}
          display={[Display.None, Display.None, Display.Block, Display.Block]}
        >
          <Bold>
            towards your
            <br />
            next box
          </Bold>
        </Body2>
      </Box>
    </Box>
  </YouGetContainer>
)
